import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline } from "react-leaflet";
import L from "leaflet";

function icon(html) {
  return L.divIcon({ html, className: "", iconSize: [40, 40], iconAnchor: [20, 20] });
}

const destIcon = icon(
  `<div style="display:flex;flex-direction:column;align-items:center">
     <div style="width:26px;height:26px;border-radius:50%;background:#3d684d;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;color:#fff;font-size:13px">📍</div>
   </div>`
);

const truckIcon = icon(
  `<div class="truck-marker">
     <div class="ring"></div>
     <div style="width:34px;height:34px;border-radius:50%;background:#d15d36;border:3px solid #fff;box-shadow:0 3px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;color:#fff;font-size:16px">🚚</div>
   </div>`
);

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) {
      map.setView(points[0], 13);
    } else if (points.length > 1) {
      map.fitBounds(points, { padding: [60, 60], maxZoom: 14 });
    }
  }, [map, points]);
  return null;
}

export default function TrackingMap({ dest, current, height = 320, driverName, customerName, path }) {
  const points = useMemo(() => {
    const p = [];
    if (current?.lat != null) p.push([current.lat, current.lng]);
    if (dest?.lat != null) p.push([dest.lat, dest.lng]);
    return p;
  }, [dest, current]);

  const line = path && path.length > 1 ? path : points;
  const center = points[0] || [40.73, -74.0];

  return (
    <div className="overflow-hidden rounded-2xl border border-stark-border" style={{ height }} data-testid="tracking-map">
      <MapContainer center={center} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
        {dest?.lat != null && (
          <Marker position={[dest.lat, dest.lng]} icon={destIcon}>
            <Popup>{customerName || "Destination"}</Popup>
          </Marker>
        )}
        {current?.lat != null && (
          <Marker position={[current.lat, current.lng]} icon={truckIcon}>
            <Popup>{driverName || "STARK Truck"}</Popup>
          </Marker>
        )}
        {line.length > 1 && (
          <Polyline positions={line} pathOptions={{ color: "#d15d36", weight: 4, opacity: 0.75 }} />
        )}
        <Fit points={points} />
      </MapContainer>
    </div>
  );
}
